import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { IInventory } from "@/types/inventory.types";
import { createDebounce } from "../helpers/debounce.helper";

const API_URL = `${import.meta.env.VITE_API_URL}`;
const makeRequestDebounced = createDebounce(makeRequest, 200);

export async function getInventoryVehicles({
  status = "",
  search = "",
  page = 1,
  itemsPerPage = "",
  fields = "city,date,situation,total,vehicles",
  startDate = "", 
  endDate = "",
  startDateAtualizadoEm = "",
  endDateAtualizadoEm = "",
} = {}) {
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
    fields,
  });

  status && params.append("filters[situation]", status);
  search && params.append("filters[city]", search);
  startDate && params.append("filters[date]", startDate.toString())
  endDate && params.append("filters[date]", endDate.toString())
  startDateAtualizadoEm && params.append("filters[startDateAtualizadoEm]", startDateAtualizadoEm.toString())
  endDateAtualizadoEm && params.append("filters[endDateAtualizadoEm]", endDateAtualizadoEm.toString())

  const url = `${API_URL}/inventory?${params.toString()}`;
  const result = await makeRequestDebounced(url) as ApiResponseType<IInventory[]> & { totalItems: number };

  return { ok: result.ok, data: result.data, totalItems: result.totalItems };
}

export async function createInventoryVehicles(inventoryData) {
  const url = `${API_URL}/inventory`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(inventoryData),
  };

  const result = makeRequestDebounced(url, options) as Promise<
    ApiResponseType<IInventory>
  >;

  return result;
}

export async function updateInventory(inventoryId: string, inventoryData: Partial<Omit<IInventory, "_id" | "city" | "date">>) {
  const url = `${API_URL}/inventory/${inventoryId}`;
  const options = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(inventoryData),
  };

  const result = makeRequestDebounced(url, options) as Promise<
    ApiResponseType<IInventory>
  >;

  return result;
}
